import React, { Fragment } from 'react';
import IntlMessages from 'util/IntlMessages';
import BasicDetailRow from 'components/basicDetailRow';

const InitiativeDetailTable = ({ displayData }) => {
    if (displayData) {
        return (
            <table className="default-table table table-sm table-responsive-sm table-hover">
                <tbody>
                    <BasicDetailRow label={<IntlMessages id="label.description" />} description={displayData?.description} />
                    <BasicDetailRow label={<IntlMessages id="label.status" />} description={displayData?.status} />
                    <BasicDetailRow label={<IntlMessages id="label.project" />} description={displayData?.project} />
                    <BasicDetailRow label={<IntlMessages id="label.startDate" />} description={displayData?.startDate} />
                    <BasicDetailRow label={<IntlMessages id="label.endDate" />} description={displayData?.endDate} />
                    <BasicDetailRow label={<IntlMessages id="label.budget" />} description={displayData?.budget} />
                    <BasicDetailRow label={<IntlMessages id="label.productCount" />} description={displayData?.productCount} />
                </tbody>
            </table>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export default InitiativeDetailTable;


// WEBPACK FOOTER //
// ./components/Agile/initiative/initiativeDetail/initiativeDetailTable/index.js